import { useEffect } from 'react';
import { Box, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Layout } from '@roc/feature-app-core';
import { GridColumnProps } from '@roc/ui';
import { observer } from 'mobx-react';
import { filterProps, noOpComparator } from '@roc/ui/utils';
import { useLoansInPendingStatusStore } from '../hooks/useLoansInPendingStatusDashboardStore';
import { LoansInPendingStatusGrid } from './loansInPendingStatusGrid';

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: '100%',
    paddingLeft: '16px',
    paddingRight: '16px',
    margin: '0 auto',
  },
  paper: {
    boxShadow: '0 0.5px 2px rgba(0, 0, 0, 0.08) !important',
    border: '0.5px solid #e0e0e0',
    padding: '16px',
    borderRadius: '12px !important',
    backgroundColor: '#fff',
  },
}));

export const LoansInPendingStatusDashboard = observer(() => {
  const classes = useStyles();
  const { loansInPendingStatusStore: store } = useLoansInPendingStatusStore();

  useEffect(() => {
    const timer = setTimeout(() => {
      store.resetAndFetchGridData();
    }, 500);

    return () => {
      clearTimeout(timer);
      store.reset();
    };
  }, []);

  const columns: GridColumnProps[] = [
    {
      field: 'loanId',
      headerName: 'Loan Id',
      width: 90,
      comparator: noOpComparator,
      ...filterProps(),
      cellRenderer: 'loanIdLinkRenderer',
    },
    {
      field: 'lenderName',
      headerName: 'Lender Name',
      width: 140,
      ...filterProps(),
      comparator: noOpComparator,
    },
    {
      field: 'loanType',
      headerName: 'Loan Type',
      width: 140,
      ...filterProps(),
      comparator: noOpComparator,
    },
    {
      field: 'loanSubtype',
      headerName: 'Loan Subtype',
      width: 140,
      ...filterProps(),
      comparator: noOpComparator,
    },
    {
      field: 'rate',
      headerName: 'Rate',
      width: 140,
      ...filterProps(),
      comparator: noOpComparator,
      cellRenderer: 'rateCellRenderer',
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 140,
      ...filterProps(),
      comparator: noOpComparator,
      cellRenderer: 'currencyCellRenderer',
    },
    {
      field: 'underwriter',
      headerName: 'Underwriter',
      width: 140,
      ...filterProps(),
      comparator: noOpComparator,
    },
  ];

  return (
    <Layout title="Loans In Pending Status" containerClass={classes.container}>
      <Box p={2}>
        <Paper className={classes.paper}>
          <LoansInPendingStatusGrid
            gridStore={store.loansInPendingStatusGridStore}
            columns={columns}
          />
        </Paper>
      </Box>
    </Layout>
  );
});
